(ns common.schema.entities.aifm-decision.schema
  (:require
   [common.schema.entities.common.options :as common-options]
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision :as decision]))

(def schema
  (concat
   decision/schema
   (su/single-ref-field :decision/deciding-legal-entity
                        "Deciding legal entity"
                        [:entity.type/company]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})

   (su/single-ref-field :decision/portfolio-manager
                        "Portfolio manager"
                        [:entity.type/account :entity.type/person]
                        {:authorization su/access-user-user
                         :default-field-visibility :in-use})

   (su/text-multiline-field :decision/portfolio-manager-notes
                            "Portfolio manager - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/pre-investment-checks-completed
                     "Pre-investment checks completed"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/pre-investment-checks-completed-notes
                            "Pre-investment checks completed - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})


   (su/keyword-field :decision/ic-recommended-to-fund
                     "Investment committee has recommended the investment to the fund"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/ic-recommended-to-fund-notes
                            "Investment committee has recommended the investment to the fund - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/fund-has-sufficient-capacity
                     "Fund has sufficient capacity to complete the deal"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/fund-has-sufficient-capacity-notes
                            "Fund has sufficient capacity to complete the deal - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})


   (su/keyword-field :decision/complies-with-investment-strategy
                     "Proposed investment complies with investment strategy, criteria and restrictions"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/complies-with-investment-strategy-notes
                            "Proposed investment complies with investment strategy, criteria and restrictions - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/portfolio-manager-approves-proposed-investment
                     "Portfolio manager approves the proposed investment"
                     common-options/condition-true-false-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/portfolio-manager-approves-proposed-investment-notes
                            "Portfolio manager approves the proposed investment - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/multi-ref-field :decision/investment-reservations
                       "Investment reservations"
                       [:entity.type/investment-reservation]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/calculated-field :decision/total-investment
                        "Total investment"
                        ; Todo
                        {:data-type   :data.type/currency-value
                         :calc-fn     (fn [{:keys [logger entity-data entity-lookup reverse-lookup tr
                                                   bigdec->float float->bigdec get-field-schema display-string]}]
                                        0)})

   (su/multi-ref-field :decision/conditions
                       "Conditions"
                       [:entity.type/decision-condition]
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

   (su/keyword-field :decision/board-approval-needed
                     "Board approval needed?"
                     common-options/needed-not-needed-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/text-multiline-field :decision/board-approval-needed-notes
                            "Board approval needed - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})

   (su/keyword-field :decision/advisory-board-approval-needed
                     "Advisory board approval needed?"
                     common-options/needed-not-needed-options
                     {:authorization su/access-user-user
                      :default-field-visibility :in-use})

   (su/option-field :decision/related-to-holding
                    "Related to holding"
                    {:authorization su/access-user-user
                     :default-field-visibility :in-use})

   (su/text-multiline-field :decision/advisory-board-approval-needed-notes
                            "Advisory board approval needed - Notes"
                            {:authorization su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision/date
    :decision/deciding-party
    :decision/portfolio-manager
    :decision/portfolio-manager-approves-proposed-investment
    :decision/pre-investment-checks-completed
    :decision/ic-recommended-to-fund
    :decision/fund-has-sufficient-capacity
    :decision/board-approval-needed
    :decision/advisory-board-approval-needed})
